import http from 'util/http'

/**
 * 保存收藏夹
 * @param {number} id 收藏夹id，可空
 * @param {string} name 收藏夹名称
 */
export function saveFavorite(id: number | undefined, name: string) {
  return http.post('/newxyrj/public/collect/folder/save', {
    collect_folder_id: id,
    folder_name: name,
  })
}
/**
 * 取消收藏
 * @param {number} id 数据id
 * @param type 类型
 */
export function cancelFavorite(id: number, type) {
  return http.post('/newxyrj/public/collect/data/cancel', {
    data_id: id,
    type,
  })
}
/**
 * 收藏视频、专题、文章
 * @param {number} cid 收藏夹id
 * @param {number} did 数据id
 * @param type 类型
 */
export function collect(cid: number, did: number, type) {
  return http.post('/newxyrj/public/collect/data/collect', {
    collect_folder_id: cid,
    data_id: did,
    type,
  })
}
/** 获取个人收藏的资源数量 */
export function collectCount() {
  return http.post('/newxyrj/public/collect/user/count', {})
}
/** 获取收藏夹 */
export function collectList() {
  return http.get('/newxyrj/public/collect/folder/list', {})
}
/**
 * 获取收藏数据
 * @param {number} id 收藏夹id
 * @param {object} param
 * @param {number} param.pageindex 页码
 * @param {number} param.pagesize 页数
 */
export function collectDataList(
  id: number,
  { pageindex, pagesize }: { pageindex: number; pagesize?: number },
) {
  return http.get('/newxyrj/public/collect/data/list', {
    collect_folder_id: id,
    pageindex,
    pagesize,
  })
}
/**
 * 获取每个文章的收藏数量以及是否收藏了
 * @param {number} id 资源id
 * @param type 类型
 */
export function collectStatus(id: number, type) {
  return http.get('/newxyrj/public/collect/data/count', {
    data_id: id,
    type,
  })
}
/**
 * 收藏夹搜索
 * @param {string} keyword 检索关键字
 * @param {object} param1
 * @param {number} param1.pageindex 分页的起始索引
 * @param {number} param1.pagesize 每页返回的行数
 */
export function searchUserCollection(
  keyword: string,
  {
    pageindex,
    pagesize = 10,
  }: {
    pageindex: number
    pagesize?: number
  },
) {
  return http.get('/newxyrj/public/collect/folder/search', {
    key_word: keyword,
    pageindex,
    pagesize,
  })
}

/**
 * 删除收藏夹
 * @param {number} id 收藏夹 id
 */
export function deleteCollectionFolder(id) {
  return http.post('/newxyrj/public/collect/folder/delete', {
    collect_folder_id: id,
  })
}
